import images from './images'
import footer_mask from '../images/footer_mask.svg'

export { images, footer_mask }